import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const encryptData = (data) => {
    try {
        const stringified = JSON.stringify(data);

        return CryptoJS.AES.encrypt(stringified, SECRET_KEY).toString();
    } catch (err) {
        console.error("Encryption failed:", err);

        return CryptoJS.AES.encrypt(JSON.stringify([]), SECRET_KEY).toString();
    }
};

export const decryptData = (ciphertext) => {
    try {
        const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        return JSON.parse(decrypted);
    } catch (err) {
        console.error("Decryption failed:", err);

        return null;
    }
};
